<template>
  <div class="settingsModal">
    <div class="van-dialog__header">
      <div class="text page_title">{{ $t('lang.swap40') }}</div>
      <div class="cancel"
           @click="handleClose"></div>
    </div>
    <div class="van-hairline--top van-dialog__footer"></div>
    <div class="van-content">
      <div class="van-content-top">
        <div class="hint page_title">{{ $t('lang.swap275') }}</div>
        <div class="van-content-title">{{ $t('lang.swap41') }}</div>
        <div class="van-content-top-tab">
          <van-button :type="gasPrice == 5000000000 ? 'primary' : 'info'"
                      class="gasPrice"
                      @click="handlePrice(5000000000)">{{ $t('lang.swap42') }}(5)</van-button>
          <van-button :type="gasPrice == 6000000000 ? 'primary' : 'info'"
                      class="gasPrice"
                      @click="handlePrice(6000000000)">{{ $t('lang.swap43') }}(6)</van-button>
          <van-button :type="gasPrice == 7000000000 ? 'primary' : 'info'"
                      class="gasPrice"
                      @click="handlePrice(7000000000)">{{ $t('lang.swap44') }}(7)</van-button>
        </div>
      </div>

      <div class="van-content-bottom">
        <div class="hint page_title">{{ $t('lang.swap276') }}</div>
        <div class="van-content-title">{{ $t('lang.swap8') }}</div>
        <div class="van-content-bottom-tab">
          <van-button :type="slippage == 0.1 ? 'primary' : 'info'"
                      class="cur"
                      @click="handleSlippage(0.1)">0.1%</van-button>
          <van-button :type="slippage == 0.5 ? 'primary' : 'info'"
                      class="cur"
                      @click="handleSlippage(0.5)">0.5%</van-button>
          <van-button :type="slippage == 1 ? 'primary' : 'info'"
                      class="cur"
                      @click="handleSlippage(1)">1.0%</van-button>
          <div class="inputDiv1">
            <van-field type="number"
                       class="slipInput"
                       input-align="center"
                       @input="onInputDeadlineSlippage"
                       v-model="slippage" />
            <div class="uint">%</div>
          </div>
        </div>
        <div class="tip1"
             v-if="slippage >= 50">{{ $t('lang.swap46') }}</div>
        <div class="tip1"
             v-else-if="slippage == 0">{{ $t('lang.swap47') }}</div>
        <div class="tip1"
             v-else-if="slippage > 5">{{ $t('lang.swap48') }}</div>
        <div class="van-content-bottom-select">
          <div class="select-list">
            <div class="label">{{ $t('lang.swap49') }}</div>
            <van-field type="number"
                       class="deadInput"
                       input-align="center"
                       @input="onInputDeadline"
                       v-model="deadline" />
          </div>
          <!-- <div class="select-list">
            <div class="label">专家模式</div>
            <div class="select"><van-switch v-model="checked" size="25px" /></div>
          </div> -->
          <div class="select-list">
            <div class="label">{{ $t('lang.swap51') }}</div>
            <div class="select">
              <van-switch v-model="multipath"
                          size="25px"
                          active-color="rgba(102, 180, 174, 1)"
                          inactive-color="rgba(240, 240, 240, 1)"
                          @change="handleMultipath" />
            </div>
          </div>
          <div class="select-list">
            <div class="label">{{ $t('lang.swap184') }}</div>
            <div class="select">
              <van-switch v-model="expert"
                          size="25px"
                          active-color="rgba(102, 180, 174, 1)"
                          inactive-color="rgba(240, 240, 240, 1)"
                          @change="handleExpert" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data () {
    return {
      gasPrice: '',
      slippage: '',
      deadline: 20,
      multipath: true,
      expert: false,
    };
  },
  computed: {
    ...mapState('ModalStore', {
      settingsModal: state => state.settingsModal,
    }),
  },
  created () {
    this.gasPrice = this.$store.state.gasPrice;
    this.slippage = this.$store.state.slippage;
    this.deadline = this.$store.state.deadline;
    this.multipath = this.$store.state.multipath;
  },
  methods: {
    handleClose () {
      this.$emit('listenClose');
    },
    handlePrice (gasPrice) {
      this.gasPrice = gasPrice;
      localStorage.setItem('gasPrice', gasPrice);
      this.$store.commit('SET_GASPRICE', gasPrice);
    },
    handleSlippage (slippage) {
      this.slippage = slippage;
      localStorage.setItem('slippage', slippage);
      this.$store.commit('SET_SLIPPAGE', slippage);
    },
    handleMultipath (multipath) {
      this.multipath = multipath;
      localStorage.setItem('multipath', multipath);
      this.$store.commit('SET_MULTIPATH', multipath);
    },
    onInputDeadline (deadLine) {
      this.deadLine = deadLine;
      localStorage.setItem('deadLine', deadLine);
      this.$store.commit('SET_DEADLINE', deadLine);
    },
    onInputDeadlineSlippage (slippage) {
      if (this.slippage >= 50) {
        this.slippage = slippage;
        return;
      }
      this.slippage = slippage;
      localStorage.setItem('slippage', slippage);
      this.$store.commit('SET_SLIPPAGE', slippage);
    },
    //专家模式
    handleExpert (ex) {
      this.expert = ex;
      localStorage.setItem('expert', this.expert);
      this.$store.commit('SET_EXPORT', this.expert);
    },
  },
};
</script>

<style lang="less" scoped>
.page_title {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 27px;
  color: var( --text-color);
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 0;
    width: 72px;
    height: 2px;
    opacity: 1;
    background: linear-gradient(121.43deg, rgba(48, 255, 252, 1) 0%, rgba(182, 133, 255, 0) 100%);
  }
}
.settingsModal {
  // width: 350px;
  background: var( --box-bg-color);

  .van-dialog {
    height: 500px;
    overflow: auto;
  }
  .van-dialog__header {
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: var( --text-color);
    border-bottom: 1px solid #282f3a;
    padding: 20px 0;
    margin: 0 20px;
    .cancel {
      width: 16px;
      height: 16px;
      background-image: url('~@/assets/img/cancel.png');
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
  .van-content {
    padding: 20px;
  }
  .hint {
    font-size: 14px;
    color: linear-gradient(90deg, #1a70fdff 0%, #26c3ffff 100%);
    margin-bottom: 20px;
  }
  .van-content-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: var( --text-color);
  }
  .van-content-top-tab {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
    .gasPrice {
      margin-right: 15px;
      width: 94px;
      font-size: 16px;
      text-align: center;
      height: 40px;
      line-height: 32px;
      color: #000;
      background: rgba(240, 240, 240, 1);
      border: 0;
      border-radius: 87px;
      cursor: pointer;
      // padding: 8px 18px;
    }
    /deep/ .van-button--primary {
      color: #fff !important;
      background: rgba(102, 180, 174, 1);
      // border: 1px solid #356ef1;
    }
  }
  .active {
    background-color: #12cdb7;
    color: #000;
  }
  //bottom
  .van-content-bottom {
    margin-top: 30px;

    .van-content-bottom-title {
      font-size: 14px;
    }
  }
  .van-content-bottom-tab {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .cur {
      margin-right: 15px;
      width: 64px;
      font-size: 12px;
      text-align: center;
      height: 40px;
      line-height: 32px;
      border-radius: 87px;
      color: #000;
      border: 0;
      background: rgba(102, 180, 174, 1);
      cursor: pointer;
    }
    /deep/ .van-button--primary {
      color: #000;
 background: rgba(102, 180, 174, 1);

      // border: 1px solid #3399ff;
    }
    .uint {
      color: #000;
    }
    .inputDiv1 {
      display: flex;
      color: #000;
      width: 84px;
      align-items: center;
      .slipInput {
        font-size: 12px;
        border-radius: 87px;
        height: 40px;
        line-height: 40px;
        background: rgba(102, 180, 174, 1);
        /deep/ .van-field__control {
          color: #000;
        }
      }

      .uint {
        color: var( --text-color);
        margin-left: 4px;
      }
    }
  }
  //select
  .van-content-bottom-select {
    margin-top: 30px;
    .select-list {
      display: flex;
      font-size: 12px;
      margin-top: 20px;
      align-items: center;
      justify-content: space-between;
      .label {
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        color: var( --text-color);
      }
      .deadInput {
        width: 64px;
        height: 30px;
        line-height: 30px;
        border-radius: 87px;
        background: rgba(102, 180, 174, 1);
        border: 0px;
        padding-left: 10px;
        color: #000;
        /deep/ .van-field__control {
          color: #000;
        }
      }
      .van-cell {
        padding: 0;
      }
      .van-cell::after {
        content: none;
      }
    }
  }
  .tip1 {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
    color: #cc9300;
  }
}
</style>
